import React, { useState } from 'react';
import { toast } from "react-hot-toast";
import { resetDevice, unenrollDevice, HardresetDevice } from 'js/Api/index';
import { Button } from '../../../../Component/CommonFormEle';
import Loader from "js/Component/Loader";

const ResetDevice = ({ user, selectedOrg, fetchCwUsers, onBackClick, refreshDeviceInfo, setSelectedUser, onResetDone, isFamilyorg  }) => {
    const [showResetConfirmModal, setShowResetConfirmModal] = useState(false);
    const [showHardResetConfirmModal, setshowHardResetConfirmModal] = useState(false);
    const [showUnEnrollConfirmModal, setShowUnEnrollConfirmModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);

    const handleResetDevice = () => {
        setShowResetConfirmModal(true);
    };

    const handleHardResetDevice = () => {
        setshowHardResetConfirmModal(true);
    };

    const handleUnEnrollDevice = () => {
        setShowUnEnrollConfirmModal(true);
    };

    const handleResetConfirm = async () => {
        setIsLoading(true);
        const result = await resetDevice(user.id);

        if (result.success) {
            await refreshDeviceInfo();
             if (onResetDone) onResetDone();
            setShowResetConfirmModal(false);
            setIsLoading(false);
            toast.success(result.message);
        } else {
            console.error("Failed to reset device");
            toast.error(result.error);
        }
    };

    const handleHardResetConfirm = async () => {
        setIsLoading(true);
        const result = await HardresetDevice(user.id);

        if (result.success) {
            await refreshDeviceInfo();
            if (onResetDone) onResetDone();
            setshowHardResetConfirmModal(false);
            setIsLoading(false);
            toast.success(result.message);
        } else {
            console.error("Failed to reset device");
            toast.error(result.error);
        }
    };

    const handleUnEnrollConfirm = async () => {
        setIsLoading(true);

        const result = await unenrollDevice(user.id);
    

        if (result.success) {
            toast.success(result.message);
            setShowUnEnrollConfirmModal(false);
            setSelectedUser(null);
            if (fetchCwUsers) {
     try { await fetchCwUsers(); } catch (e) { /* optional: console.log(e) */ }
   }
        } else {
            toast.error(result.error);
            setShowUnEnrollConfirmModal(false);
        }

        setShowUnEnrollConfirmModal(false);
        setIsLoading(false);
    };

    return (
        <div className="reset-device-container" style={{ padding: "20px" }}>
            <div className="reset-section" style={{ marginBottom: "40px" }}>
                <div class="mb-2">
                    <Button onClick={handleResetDevice} variant="reset">
                        Soft Reset device
                    </Button>
                </div>
               
                <p style={{
                    color: "#666",
                    fontSize: "14px",
                    maxWidth: "700px",
                    lineHeight: "1.5"
                }}>
                    Performs a soft-reset on CareWindow, leaving it enrolled in the Carer Dashboard and connected to the Wi-Fi network. Use this when a resident has left and the device is being assigned to a new user.
                </p>
            </div>
            <div className="reset-section" style={{ marginBottom: "40px" }}>
                <div class="mb-2">
                    <Button onClick={handleHardResetDevice} variant="reset">
                        Hard Reset device
                    </Button>
                </div>
                <p style={{
                    color: "#666",
                    fontSize: "14px",
                    maxWidth: "700px",
                    lineHeight: "1.5"
                }}>
                    Performs a hard-reset on CareWindow, this will clean up everything on it, including the Wi-Fi connection. Use this when you want to have a brand-new CareWindow.
                </p>
            </div>
            {!isFamilyorg &&
                <div className="unenroll-section">
                    <div class="mb-2">
                        <Button onClick={handleUnEnrollDevice} variant="reset">
                            Un-enrol device
                        </Button>
                    </div>
                    <p style={{
                        color: "#666",
                        fontSize: "14px",
                        maxWidth: "700px",
                        lineHeight: "1.5"
                    }}>
                        Removes the device from the Carer Dashboard. Family settings will be left intact.
                    </p>
                </div>
            }

            {/* Reset Confirmation Modal */}
            {showResetConfirmModal && (
                <div className="modal" style={{ display: "block" }} role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Reset</h5>
                                <Button onClick={() => setShowResetConfirmModal(false)} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to reset this device? This will clear all user data while keeping the device enrolled.</p>
                            </div>
                            <div className="modal-footer">
                                <Button onClick={() => setShowResetConfirmModal(false)} variant="cancel">
                                    Cancel
                                </Button>
                                {isLoading && <Loader />}
                                <Button onClick={handleResetConfirm} variant="blue" disabled={isLoading}>
                                    Confirm Reset
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Hard Reset Confirmation Modal */}
            {showHardResetConfirmModal && (
                <div className="modal" style={{ display: "block" }} role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Hard Reset</h5>
                                <Button onClick={() => setshowHardResetConfirmModal(false)} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to <b>Hard reset</b> this device? This will clear all user data while keeping the device enrolled.</p>
                            </div>
                            <div className="modal-footer">
                                <Button onClick={() => setshowHardResetConfirmModal(false)} variant="cancel">
                                    Cancel
                                </Button>
                                {isLoading && <Loader />}
                                <Button onClick={handleHardResetConfirm} variant="blue" disabled={isLoading}>
                                    Confirm Hard Reset
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}

            {/* Un-enroll Confirmation Modal */}
            {showUnEnrollConfirmModal && (
                <div className="modal" style={{ display: "block" }} role="dialog">
                    <div className="modal-dialog">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Confirm Un-enrollment</h5>
                                <Button onClick={() => setShowUnEnrollConfirmModal(false)} variant="modal-close">
                                    &times;
                                </Button>
                            </div>
                            <div className="modal-body">
                                <p>Are you sure you want to un-enroll this device from the Carer Dashboard?</p>
                            </div>
                            <div className="modal-footer">
                                <Button onClick={() => setShowUnEnrollConfirmModal(false)} variant="cancel">
                                    Cancel
                                </Button>
                                <Button onClick={handleUnEnrollConfirm} variant="blue" disabled={isLoading}>
                                    Confirm Un-enrollment
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ResetDevice;